import { SharePointCloud } from 'features/SharePointCloud';
import { ViewPointCloud } from 'features/ViewPointCloud';
import { createBrowserRouter } from 'react-router-dom';

export const router = createBrowserRouter([
    {
        path: '/psp/view/sh/:pucKey',
        element: <SharePointCloud />,
    },
    {
        path: '/psp/view/v/:projectId',
        element: <ViewPointCloud />,
    },
    {
        path: '*',
        element: <div>Not found</div>,
    },
]);
